/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number, string } from 'prop-types'

const ArrowRightSmall = ({ color = 'forest', height = 11, ...props }) => {
  return (
    <svg
      width={20}
      height={height}
      viewBox="0 0 20 11"
      sx={{ fill: color }}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 5.267L14.343 0l-1.414 1.217 3.243 3.01H0v1.958h16.172L12.929 9.53 14.343 11 20 5.267z"
        fill={color}
      />
    </svg>
  )
}

ArrowRightSmall.propTypes = {
  color: string,
  height: number,
}

export default ArrowRightSmall
